import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { Constant, PlatFormType } from '../../common/constant/constant';
import { Title } from '@angular/platform-browser';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit , OnDestroy{

  public headerLogo: string ='assets/images/login/collabtic-logo-blacktext.png';
  public loading: boolean = true;
  public user: any = '';
  public userId: any = '';
  public email: any = '';
  public domainId: any = '';
  public bodyHeight: number; 
  public innerHeight: number;
  public responseMsg: string = '';
  public verifiedOKFlag: boolean = false;
  public disableManager: boolean = false;
  public noManager;
  public landingUrl: string = "landing-page";
  public loginUrl: string = "landing-page";
  public addManagerUrl: string = "landing-page";
  public contentTypeId: string = "2";
  public menuId: string = "2";
  public actionId: string = "9";
  public actionVal: string = "0";
  public bodyElem;
  public userIdFlag: boolean = false;
  public responseFlag: boolean = false;
  public emailResponseFlag: boolean = false;

  public emailId: any = '';
  public emailErrorFlag: boolean = false;
  public emailErrorMsg: any = '';
  public mailDisableFlag: boolean = true;
  public emailInputFlag:boolean;
  public platformId: any = '';

  constructor(private router: Router, private route: ActivatedRoute, private authenticationService: AuthenticationService,private titleService: Title, private commonApi: CommonService,)
   { 
    this.titleService.setTitle(
      localStorage.getItem("platformName") + " - Email Unsubscribe"
    );
   }

  ngOnInit(): void {
    this.actionId = this.route.snapshot.params['actionId'] == undefined ? this.actionId : this.route.snapshot.params['actionId'];
    
    this.platformId=localStorage.getItem('platformId');
    if(this.platformId == PlatFormType.MahleForum)
    {
      this.headerLogo = 'assets/images/mahle-logo.png';
    }
    else if(this.platformId == PlatFormType.CbaForum)
    {
      this.headerLogo = 'assets/images/cba-logo.png';
    }
    else
    {
      this.headerLogo = 'assets/images/login/collabtic-logo-blacktext.png';
    }    

    this.bodyElem = document.getElementsByTagName("body")[0];
    this.bodyElem.classList.add("auth");               

    this.bodyHeight = window.innerHeight;
    this.setScreenHeight();

    this.user = this.authenticationService.userValue;

    console.log(this.user);

    if(this.user != null && this.user != undefined && this.user != ''){  
      this.domainId = this.user.domain_id;
      this.userId = this.user.Userid; 
    }

    if(this.userId == null || this.userId == 'null' || this.userId == 'undefined' || this.userId == undefined){
      this.userId = '';
    } 
    if(this.domainId == null || this.userId == 'null' || this.domainId == 'undefined' || this.domainId == undefined){
      this.domainId = '';
    }


    if((this.domainId != '' && this.userId != '' && this.platformId != PlatFormType.CbaForum) || (this.platformId == PlatFormType.CbaForum && this.domainId == '0' && this.userId != '')){
      this.userIdFlag = true;
      this.verifiedEmail(); 
    }
    else{
        if(this.domainId == '' || this.userId == ''){
          let currentURL = window.location.href;
          let splittedURL1 = currentURL.split("://");
          //splittedURL1[1] = "collabtic.collabtic.com"; // check url
          let splittedURL2 = splittedURL1[1].split(".");  
          let domainName = splittedURL2[0];
          this.getDomainInfo(domainName);
          if(domainName == 'tac'){
            this.platformId =  PlatFormType.CbaForum;
          }
        }
    }
 
  }

  // Set Screen resize Height
  @HostListener('window:resize', ['$event'])
	onResize(event) {
		this.innerHeight = event.target.innerHeight;
	}
  // Set Screen Height
  setScreenHeight() { 
    this.innerHeight = this.bodyHeight;    
  }

  updateEmail(actionId,type){
    const mData = new FormData();
    mData.append('apikey', Constant.ApiKey);
    mData.append('fromEmail', "1");
    mData.append('userId', this.userId);
    mData.append('domainId', this.domainId);  
    mData.append('contentTypeId', this.contentTypeId);
    mData.append('menuId', this.menuId);
    mData.append('actionId', actionId);
    mData.append('actionVal', this.actionVal);
    if(type=='email'){
      mData.append('email', this.emailId);      
    }
    this.commonApi.UpdateDispatchNotification(mData).subscribe(response => {});
  }
  //verifiedOK
  verifiedEmail(type=''){    
    
    if(this.platformId == PlatFormType.CbaForum){
      if(this.actionId == "9"){
        this.updateEmail(16,type);
        this.updateEmail(17,type);
      }
    }

    const mData = new FormData();
    mData.append('apikey', Constant.ApiKey);
    mData.append('fromEmail', "1");
    mData.append('userId', this.userId);
    mData.append('domainId', this.domainId);  
    mData.append('contentTypeId', this.contentTypeId);
    mData.append('menuId', this.menuId);
    mData.append('actionId', this.actionId);
    mData.append('actionVal', this.actionVal);
    if(type=='email'){
      mData.append('email', this.emailId);
    }
    
    this.commonApi.UpdateDispatchNotification(mData).subscribe(response => {    
      this.loading = false;  
      this.emailResponseFlag = true;
      if(response.status == "Success") { 
          this.verifiedOKFlag = true;
          this.responseMsg = response.message;                 
        }
        else {   
          this.verifiedOKFlag = false;             
          this.responseMsg = response.message;                  
        }
              
      },
      (error => { 
        this.responseMsg = error ;                     
      })
      );   
  }

  getDomainInfo(domainName){
    const subDomainData = new FormData();
    subDomainData.append('apiKey', Constant.ApiKey);
    subDomainData.append('domainName', domainName);
    this.authenticationService.validateSubDomain(subDomainData).subscribe((response) => {
      this.loading = false;
      if (response.status == "Success") {
        let domainData = response.data[0];
        this.domainId = domainData.domainId;
        if(this.userId == ''){
          this.userIdFlag = false;
          this.loading = false;  
        }
        else{
          this.userIdFlag = true;
          this.verifiedEmail(); 
        }
      }
      else {
        this.responseMsg = response.result; 
        this.verifiedOKFlag = false; 
      }
    },
    (error => {
      this.responseMsg = error; 
      this.verifiedOKFlag = false;                   ; 
     })
    );
  }

  public onKeypress(event: any) {
    let inputVal = event.target.value.trim();
    let inputLength = inputVal.length;
    this.emailInputFlag = (inputLength>0) ? true : false;
    this.emailErrorFlag = false;
    this.emailErrorMsg = '';
    this.mailDisableFlag = !this.emailInputFlag;
  }

  checkEmailValition(value: any,type='') {
    let inputVal = value.trim();
    let inputLength = inputVal.length;
    this.emailInputFlag = (inputLength>0) ? true : false;
    if(this.emailInputFlag){
      const email = inputVal;
      const emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const isValid = emailPattern.test(email);
      console.log(isValid);
      this.emailErrorFlag = !isValid;
      this.emailErrorMsg = this.emailErrorFlag ? "Invalid Email" : '';    
      this.mailDisableFlag = this.emailErrorFlag;
      if(!this.mailDisableFlag && type == 'submit'){
        this.verifiedEmail('email');
        this.loading = true;
      }
    }
    else{
      this.emailErrorFlag = false;
      this.emailErrorMsg = '';
      this.mailDisableFlag = true;
    } 
  }
  sendEmail(){
    if(!this.mailDisableFlag){      
      this.checkEmailValition(this.emailId, 'submit');
    }
  }



  ngOnDestroy(){
    this.bodyElem.classList.remove("auth");
  }


}

